import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { Link } from 'react-router'
import { inject, observer } from 'mobx-react'
import Icon from '../../shared/components/Icon'
import { API_SERVER_URL } from '../../config'

@inject('auth')
@observer
export
default class PaneListEntry
  extends Component {

  static propTypes = {
    auth: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
  }

  @autobind
  handleImpersonate() {
    this.props.auth.impersonate(this.props.user.id)
  }

  render() {
    const { user, user: { museum } } = this.props

    let icon = 'user-lilac'

    if (user.acs.isAuthorized('SUPERADMIN')) {
      icon = 'user-superadmin'
    }
    else if (user.acs.isAuthorized('ADMIN')) {
      icon = 'user-admin'
    }

    const showImpersonate = this.props.auth.user.acs.isAuthorized('SUPERADMIN')
      && this.props.auth.user.identificationId !== user.identificationId

    return (
      <li className="identification iconized">
        <div>
          <Icon
            className="nav-list-icon"
            size={18}
            name={icon}
          />
          <small>{user.address}</small>
          {' '}
          <strong>
            {user.surname}
            ,
            {' '}
            {user.firstname}
          </strong>
          <br />
          {museum
            ? (
              <small>
                (
                {museum.name}
                {user.acs.isAuthorized('SUPERADMIN')
                  ? (
                    <span>
                      ,
                      {museum.districtId}
                    </span>
                  )
                  : null}
                )
                <br />
              </small>
            )
            : null}
          <a href={`mailto:${user.email}`}>
            {/*<Icon
            size={14}
            name="star-envelop"
          />&nbsp;*/}
            {user.email}
          </a>
          <span className="tools">

            {(museum && museum.id)
              ? (
                <a
                  href={user.liveMuseum
                    ? `${API_SERVER_URL}backend/museum/${museum.id}/form`
                    : null}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={user.liveMuseum
                    ? 'Bewertungszettel'
                    : 'Das Museum muss freigegeben sein um einen Bewertungszettel erstellen zu können'}
                  disabled={!user.liveMuseum}
                >
                  <Icon
                    className="tool-icon"
                    size={18}
                    name="rating-form-grey"
                  />
                </a>
              )
              : null}

            {(museum && museum.id)
              ? (
                <a
                  href={user.liveMuseum
                    ? `${API_SERVER_URL}backend/museum/${museum.id}/qr`
                    : null}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={user.liveMuseum
                    ? 'QR-Code'
                    : 'Das Museum muss freigegeben sein um einen QR-Code erstellen zu können'}
                  disabled={!user.liveMuseum}
                >
                  <Icon
                    className="tool-icon"
                    size={18}
                    name="qr-code-grey"
                  />
                </a>
              )
              : null}

            <Link
              to={`/user/${user.id}/edit`}
              title="Kennung bearbeiten"
            >
              <Icon
                className="padded-tool-icon tool-icon"
                size={18}
                name="pencil-grey"
              />
            </Link>
            {showImpersonate
              ? (
                <a
                  onClick={this.handleImpersonate}
                  title="Impersonate"
                >
                  <Icon
                    className="tool-icon"
                    size={18}
                    name="impersonate-grey"
                  />
                </a>
              )
              : null}
          </span>
        </div>
      </li>
    )
  }

}



// WEBPACK FOOTER //
// ./src/user/components/PaneListEntry.js